import Constants from '../utils/consts';
import Utils from '../utils/utils';

var http = require('follow-redirects').https;
var qs = require('querystring');

export default async function createDatabaseFromUser(uname, token, pass, ragSoc, logo, dbName, indirizzo, citta, provincia, cap, email, phone) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'createDatabaseUser.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'ragione_sociale': Utils.escapeString(ragSoc), 
            'logo': logo,
            'db_name': dbName, 
            'main_color': '#F58320',
            'secondary_color': '#FFC260', 
            'menu_font_color': '#444444',
            'user_admin': uname,
            'pass_admin': pass, 
            'address': Utils.escapeString(indirizzo), 
            'city': Utils.escapeString(citta), 
            'province': provincia, 
            'cap': cap, 
            'email': email, 
            'phone': Utils.escapeString(phone)
        });

        req.write(postData);

        req.end();
    });
}
